// extracted by mini-css-extract-plugin
export default {"root":"WtQ81","suffix":"y4ddZ","suffixIcon":"ogvsQ"};